import { useContext } from 'react'
import { AppContext } from '@state/context'
import { hideConfirmation, showConfirmation } from '@state/actions/confirmationActions'

let resolveCallback

const useConfirm = () => {
  const [, dispatch] = useContext(AppContext)
  const onConfirm = () => {
    closeConfirm()
    resolveCallback(true)
  }

  const onCancel = () => {
    closeConfirm()
    resolveCallback(false)
  }

  const closeConfirm = () => {
    dispatch(hideConfirmation())
  }

  const confirm = (data) => {
    dispatch(showConfirmation(data))

    return new Promise((res, rej) => {
      resolveCallback = res
    })
  }

  return { confirm, onConfirm, onCancel }
}

export { useConfirm }
